(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportMaterialCategoryDeleteController',PatchReportMaterialCategoryDeleteController);

    PatchReportMaterialCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchReportMaterialCategory'];

    function PatchReportMaterialCategoryDeleteController($uibModalInstance, entity, PatchReportMaterialCategory) {
        var vm = this;
        vm.patchReportMaterialCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchReportMaterialCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
